<head>
  <meta id="viewport" name="viewport" content="width=device-width, initial-scale=0.5">
</head>
<body>
  <!--The content below is only a placeholder and can be replaced.-->
  <app-main-title class="app-main-title"></app-main-title>
  <div class="app-main-component">
    <router-outlet></router-outlet>
  </div>
</body>